var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { MarkButton, BlockButton } from "../../Atoms";
import { ElementType } from "../../../types";
import LinkEditor from "../LinkEditor";
var StyleControls = function (_a) {
    var controls = _a.controls;
    return (_jsx(Stack, __assign({ direction: "row", alignItems: "center" }, { children: controls.map(function (control, idx) {
            return control.style === ElementType.Link ? (_jsx(LinkEditor, { last: controls.length === idx + 1 }, control.style)) : control.type === "mark" ? (_jsx(MarkButton, { control: control, last: controls.length === idx + 1 }, control.style)) : (_jsx(BlockButton, { control: control, last: controls.length === idx + 1 }, control.style));
        }) })));
};
export default StyleControls;
